<template>
    
    <div class="community">
        
        <Header/>

        <div class="communitycontainer">
            <!-- Bizzabo Web Speakers Begin -->
            <iframe src="https://www.veeamlive.com/page/1588755/speakers" frameborder="0"></iframe>
        </div>

    </div>

</template>





<script>
    import Header from "../components/Header.vue";

    export default {
        name: 'Speakers',
        components: {
            Header
        },/*
        mounted() {
            /* Bizzabo Web Speakers Begin 
            var bz = document.createElement('script');
            bz.type = 'text/javascript';
            bz.async = !0;
            bz.src = 'https://organizer.bizzabo.com/widgets/sections/sections.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(bz, s);
            /* Bizzabo Web Speakers End 
        }*/
    }
</script>



<style scoped>


    .community {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }

    .communitycontainer {
        position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    }

    iframe {
        display: block; width: 100%; height: 100%; border: none;
    }

</style>